import { UseGenerativeAIOptions, User } from '@akin-home/amplify';
import { getFirst } from '@akin-home/arrays';
import { UserModel } from '../types';
const ONBOARDING_BASE_URL = 'https://home-onboarding.akin.com';

export const insertParticipants =
  (users?: User[]) =>
  <T extends { participantIDs: string[]; participants: User[] }>(
    item: T
  ): T => ({
    ...item,
    participants: users?.filter((u) =>
      item.participantIDs?.includes(u.id as string)
    ),
  });

/** Gets onboarding link if the user has an onboarding token assigned */
export const getOnboardingLink = (user: User): string | undefined => {
  const { onboardingToken } = user;

  if (!onboardingToken || !ONBOARDING_BASE_URL) return undefined;

  return `${ONBOARDING_BASE_URL}/?token=${onboardingToken}`;
};

export const setUseGenerativeAI = (
  user: UserModel,
  use_generative_ai: boolean
): UserModel => ({
  ...user,
  use_generative_ai: use_generative_ai
    ? {
        __typename: 'UseGenerativeAIOptions',
        name: 'chatgpt',
      }
    : undefined,
});

export const setUseGenerativeAIFields =
  (use_generative_ai: Partial<UseGenerativeAIOptions>) =>
  (user: UserModel) => ({
    ...user,
    use_generative_ai: {
      ...user.use_generative_ai,
      ...use_generative_ai,
      __typename: 'UseGenerativeAIOptions' as const,
    },
  });

export const getUserChatID = (user: UserModel) =>
  assembleUserChatID(user.username, user.id);

export const assembleUserChatID = (username: string, id: string) =>
  username + '#' + id;

export const findDefaultUser = (users: UserModel[]) => {
  return findManagerUser(users) || findPrimaryUser(users) || getFirst(users);
};

export const findManagerUser = (users: UserModel[]) =>
  users.find(({ role }) => role === 'manager');

export const findPrimaryUser = (users: UserModel[]) =>
  users.find((user) => user.primary);

export const getUserChatAppID = (user: UserModel) =>
  parseInt(user.chatApplicationId || '1');
